export default __webpack_public_path__ + "static/media/er1.b3239a79.png";